import { IconSvg } from '@graphcommerce/next-ui'
import transport from '@graphcommerce/next-ui/icons/transport.svg'
import { Trans } from '@lingui/react'
import { Alert, SxProps, Theme } from '@mui/material'

type CartFreeShippingAlertProps = {
  shippingSubtotal: number | null | undefined
  sx?: SxProps<Theme>
}

export function CartFreeShippingAlert(props: CartFreeShippingAlertProps) {
  const { shippingSubtotal, sx = [] } = props
  const shippingPrice = Number(import.meta.graphCommerce.freeShippingTreshold)

  if (!shippingSubtotal) return null

  let shippingPriceToGo = shippingPrice - shippingSubtotal
  shippingPriceToGo = parseFloat(shippingPriceToGo.toFixed(2))

  if (shippingPriceToGo <= 0) return null

  return (
    <Alert
      icon={
        <IconSvg
          src={transport}
          size='medium'
          sx={(theme) => ({ color: theme.palette.text.primary })}
        />
      }
      severity='info'
      sx={[
        (theme) => ({
          mb: theme.spacings.xxs,
          borderRadius: theme.shape.borderRadius / 2,
          '& .MuiAlert-message': { py: '6px' },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Trans
        id='Add {0} more to your cart to get free shipping'
        values={{
          0: <strong>{shippingPriceToGo.toString().replace('.', ',')} euro</strong>,
        }}
      />
    </Alert>
  )
}
